import registrationInstance from '../../instance'

const postLogin = ({ email, companyIndex, password, recaptchaValue }) => {
	return registrationInstance.post('/auth/login',
		{ email, companyIndex, password },
		{ headers: { 'G-Recaptcha-Response': recaptchaValue } })
}

export default postLogin
